<template>
	<div
		class="description_container"
		:class="{ opened: isOpened, 'cursor-pointer': isOverflowing }"
		@click="isOpened = !isOpened"
	>
		<div ref="textBoxRef" class="text_box">
			<div v-dompurify-html="props.description"></div>
		</div>
		<div class="img_box">
			<img v-if="isOverflowing" src="@/assets/img/common/arrow_down.svg" alt="open" loading="lazy" />
		</div>
	</div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';

// -----variable-----
const props = defineProps<{
	description: string;
}>();

const isOpened = ref(false);
const textBoxRef = ref<HTMLElement | null>(null);
const isOverflowing = ref(false);

// -----function-----
// textBox의 overflow 상태를 확인하는 함수
const checkOverflow = () => {
	if (textBoxRef.value) {
		isOverflowing.value = textBoxRef.value.scrollHeight > textBoxRef.value.clientHeight;
	}
};

// -----composition-----
onMounted(checkOverflow);
</script>

<style lang="scss" scoped>
.description_container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1rem;
	background-color: var(--color-bg-mid);
	padding: 1.2rem;
	border-radius: 0.8rem;
	.text_box {
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
		overflow: hidden;
		div {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-light);
			line-height: 2.3rem;
			text-align: left;
		}
	}
	.img_box img {
		transform: rotate(0deg);
		transition: transform 0.5s ease;
	}
}
.opened {
	.text_box {
		// -webkit-line-clamp: unset; // 앱에서는 -webkit-line-clamp의 값이 동적으로 설정되지 않는 문제 발생
		display: block;
		overflow: visible;
	}
	.img_box img {
		transform: rotate(180deg);
	}
}
</style>
